angular.module('invoice')
    .component('invoiceFlagBadge', {
        bindings: {
            flag: '<',
            metadata: '<'
        },
        templateUrl: 'app/invoice/flag-badge.html',
        controller: function () {
            this.$onInit = () => {

            }

            this.hasPopoverData = () => {
                return !!(this.metadata && (this.metadata.setAt || this.metadata.setBy))
            }
        }
    })
